import axios from "axios";
const url = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : "http://localhost:3000";

export const postApi = (endPoint, data, config = {}) => {
  return axios
    .post(url + endPoint, data, config)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const putApi = (endPoint, data, config = {}) => {
  return axios
    .put(url + endPoint, data, config)
    .then((res) => res.data)
    .catch((error) => {
      throw error;
    });
};

export const patchApi = (endPoint, data, config = {}) => {
  return axios
    .patch(url + endPoint, data, config)
    .then((res) => res.data)
    .catch((error) => {
      throw error;
    });
};

export const getApi = (queryStr = "", config = {}) => {
  return axios
    .get(url + queryStr, config)
    .then((res) => res.data)
    .catch((error) => {
      throw error;
    });
};
